// removed by extract-text-webpack-plugin
module.exports = {"comment-textarea":"Comment__comment-textarea___1Ar8C","comment-error":"Comment__comment-error___IVcI4"};